import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { Helmet } from "react-helmet";
import Listprint from "../../Listprint";
import YearForm from "../years/YearForm";
import ArchiveForm from "./ArchiveForm";

class ArchiveDetail extends Component {
    state = {
        loading: true, loadError: false, isModalArchive: false, isModalArch: false,
        year: "", formDataarchive: null, students: [], selectedStudents: [], modalStudents: [], displayArray: [],
        columns: [
            { label: "Matricule", field: "matricule", sort: "asc", width: 110 },
            { label: "Élève", field: "student", sort: "asc", width: 230 },
            { label: "Statut", field: "status", sort: "asc", width: 100 },
            { label: "Responsable", field: "responsible", sort: "asc", width: 180 },
            { label: "Archivé le", field: "created_at", sort: "asc", width: 120 }
        ]
    };

    componentDidMount() { this.loadArchive(); }

    loadArchive = async () => {
        this.setState({ loading: true, loadError: false });
        try {
            const [yearResponse, studentsResponse] = await Promise.all([
                axios.get(`years/${this.props.match.params.year}`),
                axios.get(`students/year/${this.props.match.params.year}`)
            ]);
            this.setState({
                year: yearResponse.status === 200 ? yearResponse.data : "",
                students: studentsResponse.status === 200 && Array.isArray(studentsResponse.data) ? studentsResponse.data : [],
                loading: false
            });
        } catch (error) { this.setState({ loading: false, loadError: true }); }
    };

    showModalArchive = (year = null) => this.setState(
        (state) => ({ isModalArchive: !state.isModalArchive, formDataarchive: year }),
        () => { if (!this.state.isModalArchive) this.loadArchive(); }
    );

    showModalArch = (saved = null) => this.setState(
        (state) => ({
            selectedStudents: saved === 1 ? [] : state.selectedStudents,
            modalStudents: [],
            isModalArch: false
        }),
        () => { if (saved === 1) this.loadArchive(); }
    );

    openClassArchive = (students) => this.setState({
        modalStudents: students,
        isModalArch: true
    });

    handleCheck = (permission) => {
        const permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
        return permissions.some((item) => permission === item.permission);
    };

    toggleStudent = (student) => this.setState((state) => ({
        selectedStudents: state.selectedStudents.some((item) => item.id === student.id)
            ? state.selectedStudents.filter((item) => item.id !== student.id)
            : [...state.selectedStudents, student]
    }));

    toggleClassStudents = (students) => this.setState((state) => {
        const selectableStudents = students.filter(
            (student) => student.operation !== "Archiver" && student.status === 1
        );
        const selectableIds = new Set(selectableStudents.map((student) => student.id));
        const allSelected = selectableStudents.length > 0 && selectableStudents.every(
            (student) => state.selectedStudents.some((item) => item.id === student.id)
        );

        return {
            selectedStudents: allSelected
                ? state.selectedStudents.filter((student) => !selectableIds.has(student.id))
                : [
                    ...state.selectedStudents,
                    ...selectableStudents.filter(
                        (student) => !state.selectedStudents.some((item) => item.id === student.id)
                    )
                ]
        };
    });

    toggleSection = (sectionId) => this.setState((state) => ({
        displayArray: state.displayArray.includes(sectionId)
            ? state.displayArray.filter((id) => id !== sectionId)
            : [...state.displayArray, sectionId]
    }));

    toggleAllSections = (sectionIds) => this.setState((state) => ({
        displayArray: state.displayArray.length === sectionIds.length ? [] : sectionIds
    }));

    getSections = () => {
        const sections = new Map();
        this.state.students.forEach((student) => {
            const sectionClass = student.sectionclass;
            const section = sectionClass?.section;
            if (!section?.id || !sectionClass?.id) return;
            if (!sections.has(section.id)) sections.set(section.id, { section, classes: new Map() });
            const group = sections.get(section.id);
            if (!group.classes.has(sectionClass.id)) group.classes.set(sectionClass.id, { sectionClass, students: [] });
            group.classes.get(sectionClass.id).students.push(student);
        });
        return [...sections.values()]
            .sort((a, b) => (a.section.entitled_section || "").localeCompare(b.section.entitled_section || "", "fr"))
            .map((group) => ({ ...group, classes: [...group.classes.values()].sort((a, b) => {
                const first = `${a.sectionClass.class?.short_entitled_class || ""} ${a.sectionClass.title || ""}`;
                const second = `${b.sectionClass.class?.short_entitled_class || ""} ${b.sectionClass.title || ""}`;
                return first.localeCompare(second, "fr", { numeric: true });
            }) }));
    };

    getStatusBadge = (status) => {
        if (status === 1) return <span className="student-status student-status--active">Actif</span>;
        if (status === 0) return <span className="student-status student-status--success">Archivé</span>;
        if (status === -1) return <span className="student-status student-status--danger">Abandon</span>;
        if (status === 2) return <span className="student-status student-status--warning">Non actif</span>;

        return <span className="student-status student-status--muted">Non actif</span>;
    };

    getRows = (students) => students?.sort((a, b) => [a.user?.last_name, a.user?.family_name, a.user?.first_name].filter(Boolean).join(" ").localeCompare([b.user?.last_name, b.user?.family_name, b.user?.first_name].filter(Boolean).join(" "), "fr")).map((student) => {
        const fullName = [student.user?.last_name, student.user?.family_name, student.user?.first_name].filter(Boolean).join(" ");
        const responsible = [student.user?.user?.first_name, student.user?.user?.last_name, student.user?.user?.family_name].filter(Boolean).join(" ");
        const canSelect = student.operation !== "Archiver" && student.status === 1;
        const isSelected = this.state.selectedStudents.some((item) => item.id === student.id);
        const archivedAt = student.year?.updatedAt || student.updatedAt;
        return {
            id: student.id,
            matricule: student.user ? <span className="archive-student-cell">
                {canSelect && <input type="checkbox" checked={isSelected} onChange={() => this.toggleStudent(student)} aria-label={`Sélectionner ${fullName || student.matricule}`} />}
                <Link to={`/students/${student.id}`} className="student-matricule">{student.matricule}</Link>
            </span> : "—",
            student: fullName || "Nom non renseigné",
            status: this.getStatusBadge(student.status),
            responsible: responsible || "—",
            created_at: archivedAt ? new Date(archivedAt).toLocaleDateString("fr-FR") : "—"
        };
    });

    renderClass = ({ sectionClass, students }, section) => {
        const className = `${sectionClass.class?.short_entitled_class || ""} ${sectionClass.title || ""}`.trim();
        const selectableStudents = students.filter(
            (student) => student.operation !== "Archiver" && student.status === 1
        );
        const selectedStudents = selectableStudents.filter((student) =>
            this.state.selectedStudents.some((item) => item.id === student.id)
        );
        const allSelected = selectableStudents.length > 0 && selectedStudents.length === selectableStudents.length;
        return <article className="student-class-card" key={sectionClass.id}>
            <div className="student-class-card__header"><div className="student-class-card__title">
                <span className="student-class-card__icon"><FeatherIcon icon="book-open" size="18" /></span>
                <div><h3>{className || "Classe"}</h3><span>{students.length} {students.length > 1 ? "élèves archivés" : "élève archivé"}</span></div>
            </div>
                {selectableStudents.length > 0 && <div className="student-class-card__actions">
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => this.toggleClassStudents(students)}>
                        <FeatherIcon icon={allSelected ? "square" : "check-square"} size="15" />
                        {allSelected ? "Tout décocher" : "Tout sélectionner"}
                    </button>
                </div>}
            </div>
            <div className="student-class-card__table"><Listprint columns={this.state.columns} rows={this.getRows(students)} title={`Archive des élèves de ${className} — ${section.short_entitled_section || section.entitled_section} — ${this.state.year?.year || ""}`} /></div>
            {selectedStudents.length > 0 && <div className="student-class-card__continue">
                <button type="button" className="btn btn-sm btn-primary" onClick={() => this.openClassArchive(selectedStudents)}>
                    <FeatherIcon icon="arrow-right-circle" size="16" />
                    Continuer avec {selectedStudents.length} élève{selectedStudents.length > 1 ? "s" : ""}
                </button>
            </div>}
        </article>;
    };

    render() {
        const sectionGroups = this.getSections();
        const sectionIds = sectionGroups.map(({ section }) => section.id);
        const activeStudents = this.state.students.filter((student) => student.status === 1).length;
        const inactiveStudents = this.state.students.length - activeStudents;
        return <main className="students-page rh-archive-detail">
            <Helmet><title>{process.env.REACT_APP_NAME} | Archive {this.state.year?.year || ""}</title></Helmet>
            <header className="students-hero archive-detail-hero">
                <div className="students-hero__content"><span className="students-hero__eyebrow">Mémoire scolaire</span><h1>Archive {this.state.year?.year || "scolaire"}</h1><p>Consultez les anciens effectifs et retrouvez chaque dossier, organisé par section et par classe.</p></div>
                <div className="students-hero__actions">
                    <Link to="/manuel#archives"  className="btn students-hero__guide">
                        <FeatherIcon icon="book-open" size={17} />
                        Doc
                    </Link> 
                    <Link to="/archives" className="btn students-hero__guide"><FeatherIcon icon="arrow-left" size="18" /> Toutes les archives</Link>
                    {this.handleCheck("Modifier année") && <button type="button" className="btn btn-primary students-hero__action" onClick={() => this.showModalArchive(this.state.year)}><FeatherIcon icon="edit-3" size="17" /> Modifier l’année</button>}
                </div>
            </header>

            {!this.state.loading && !this.state.loadError && <section className="students-stats" aria-label="Résumé de l’archive">
                <article className="students-stat"><span className="students-stat__icon"><FeatherIcon icon="users" size="20" /></span><div><strong>{this.state.students.length}</strong><span>Élèves archivés</span></div></article>
                <article className="students-stat"><span className="students-stat__icon students-stat__icon--success"><FeatherIcon icon="user-check" size="20" /></span><div><strong>{activeStudents}</strong><span>Dossiers actifs</span></div></article>
                <article className="students-stat"><span className="students-stat__icon students-stat__icon--warning"><FeatherIcon icon="user-x" size="20" /></span><div><strong>{inactiveStudents}</strong><span>Dossiers non actifs</span></div></article>
                <article className="students-stat"><span className="students-stat__icon students-stat__icon--purple"><FeatherIcon icon="layers" size="20" /></span><div><strong>{sectionGroups.length}</strong><span>Sections représentées</span></div></article>
            </section>}

            {this.state.loading && <div className="students-feedback"><FeatherIcon className="user-search-spin" icon="loader" /></div>}
            {!this.state.loading && this.state.loadError && <div className="students-feedback students-feedback--error"><FeatherIcon icon="alert-circle" size="30" /><h2>Impossible de charger cette archive</h2><p>Vérifiez votre connexion puis réessayez.</p><button type="button" className="btn btn-primary btn-sm" onClick={this.loadArchive}><FeatherIcon icon="refresh-cw" size="15" /> Réessayer</button></div>}
            {!this.state.loading && !this.state.loadError && sectionGroups.length === 0 && <div className="students-feedback"><span className="students-feedback__icon"><FeatherIcon icon="archive" size="32" /></span><h2>Cette archive est vide</h2><p>Aucun dossier élève n’est associé à cette année scolaire.</p></div>}

            {!this.state.loading && !this.state.loadError && sectionGroups.length > 0 && <section className="students-sections">
                <div className="students-sections__heading archive-detail-heading"><div><span>Organisation</span><h2>Élèves par section</h2></div><div className="archive-detail-heading__actions">
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => this.toggleAllSections(sectionIds)}><FeatherIcon icon={this.state.displayArray.length === sectionIds.length ? "chevrons-up" : "chevrons-down"} size="16" />{this.state.displayArray.length === sectionIds.length ? "Tout replier" : "Tout déplier"}</button>
                </div></div>
                {sectionGroups.map(({ section, classes }) => {
                    const isOpen = this.state.displayArray.includes(section.id);
                    const total = classes.reduce((sum, item) => sum + item.students.length, 0);
                    return <article className={`student-section ${isOpen ? "is-open" : ""}`} key={section.id}>
                        <button type="button" className="student-section__toggle" onClick={() => this.toggleSection(section.id)} aria-expanded={isOpen}><span className="student-section__badge">{section.short_entitled_section || "Section"}</span><span className="student-section__name"><strong>{section.entitled_section}</strong><small>{classes.length} {classes.length > 1 ? "classes" : "classe"} · {total} {total > 1 ? "élèves" : "élève"}</small></span><span className="student-section__chevron"><FeatherIcon icon="chevron-down" size="20" /></span></button>
                        {isOpen && <div className="student-section__content">{classes.map((classGroup) => this.renderClass(classGroup, section))}</div>}
                    </article>;
                })}
            </section>}

            <YearForm isModal={this.state.isModalArchive} formData={this.state.formDataarchive} showModal={this.showModalArchive} archive />
            <ArchiveForm isModal={this.state.isModalArch} formData={this.state.modalStudents} showModal={this.showModalArch} />
        </main>;
    }
}

export default ArchiveDetail;
